<div class="space-y-6 text-text-primary">

    <!-- Header with Actions -->
    <div class="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div>
            <h2 class="text-xl font-bold tracking-tight mb-1">{{ 'brokerDashboard.units.title' | translate }}</h2>
            <p class="text-text-muted text-sm">{{ totalItems }} {{ totalItems !== 1 ? ('brokerDashboard.units.units' |
                translate) : ('brokerDashboard.units.unit' | translate) }} {{ 'brokerDashboard.units.total' | translate
                }}</p>
        </div>
        <button [routerLink]="['/dashboard/real_estate_broker/add-property']" class="btn btn-primary">
            <i class="fas fa-plus"></i>
            {{ 'brokerDashboard.units.createUnit' | translate }}
        </button>
    </div>

    <!-- Filters -->
    <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle p-6">
        <h3 class="text-text-primary font-bold mb-4 uppercase tracking-wider text-sm">{{ 'brokerDashboard.units.filters'
            | translate }}</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            <div>
                <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                    'brokerDashboard.units.search' | translate }}</label>
                <input type="text" [(ngModel)]="filters.title"
                    placeholder="{{ 'brokerDashboard.units.searchPlaceholder' | translate }}"
                    class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary placeholder-text-muted focus:ring-2 focus:ring-primary focus:border-primary transition">
            </div>

            <div>
                <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                    'brokerDashboard.units.unitType' | translate }}</label>
                <select [(ngModel)]="filters.unitType"
                    class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                    <option value="" class="bg-surface">{{ 'brokerDashboard.units.allTypes' | translate }}</option>
                    <option value="apartment" class="bg-surface">{{ 'brokerDashboard.units.apartment' | translate }}
                    </option>
                    <option value="villa" class="bg-surface">{{ 'brokerDashboard.units.villa' | translate }}</option>
                    <option value="studio" class="bg-surface">{{ 'brokerDashboard.units.studio' | translate }}</option>
                    <option value="chalet" class="bg-surface">{{ 'brokerDashboard.units.chalet' | translate }}</option>
                </select>
            </div>

            <div>
                <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                    'brokerDashboard.units.purpose' | translate }}</label>
                <select [(ngModel)]="filters.purpose"
                    class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                    <option value="" class="bg-surface">{{ 'brokerDashboard.units.allPurposes' | translate }}</option>
                    <option value="rent" class="bg-surface">{{ 'brokerDashboard.units.rent' | translate }}</option>
                    <option value="sale" class="bg-surface">{{ 'brokerDashboard.units.sale' | translate }}</option>
                    <option value="sale_and_rent" class="bg-surface">{{ 'brokerDashboard.units.saleAndRent' | translate
                        }}</option>
                </select>
            </div>

            <div>
                <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                    'brokerDashboard.units.status' | translate }}</label>
                <select [(ngModel)]="filters.status"
                    class="w-full px-4 py-3 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                    <option value="" class="bg-surface">{{ 'brokerDashboard.units.allStatuses' | translate }}</option>
                    <option value="active" class="bg-surface">{{ 'brokerDashboard.units.active' | translate }}</option>
                    <option value="rented" class="bg-surface">{{ 'brokerDashboard.units.rented' | translate }}</option>
                    <option value="sold" class="bg-surface">{{ 'brokerDashboard.units.sold' | translate }}</option>
                    <option value="inactive" class="bg-surface">{{ 'brokerDashboard.units.inactive' | translate }}
                    </option>
                </select>
            </div>
        </div>

        <div class="flex gap-3">
            <button (click)="applyFilters()"
                class="px-5 py-2.5 bg-primary text-white rounded-xl font-bold shadow-primary-glow hover:bg-primary-hover transition-colors">
                {{ 'brokerDashboard.units.applyFilters' | translate }}
            </button>
            <button (click)="resetFilters()"
                class="px-5 py-2.5 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.units.resetFilters' | translate }}
            </button>
        </div>
    </div>

    <!-- Loading Skeleton -->
    @if (isLoading) {
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        @for (item of Array(6); track $index) {
        <div class="bg-surface-elevated rounded-2xl border border-border shadow-subtle overflow-hidden animate-pulse">
            <div class="h-48 bg-surface-hover"></div>
            <div class="p-5">
                <div class="w-3/4 h-5 bg-surface-hover rounded mb-3"></div>
                <div class="w-1/2 h-4 bg-surface-hover rounded mb-4"></div>
                <div class="flex gap-3 mb-4">
                    <div class="w-12 h-4 bg-surface-hover rounded"></div>
                    <div class="w-12 h-4 bg-surface-hover rounded"></div>
                    <div class="w-16 h-4 bg-surface-hover rounded"></div>
                </div>
                <div class="flex gap-2 border-t border-border-subtle pt-4">
                    <div class="w-20 h-8 bg-surface-hover rounded-lg"></div>
                    <div class="w-10 h-8 bg-surface-hover rounded-lg"></div>
                    <div class="w-10 h-8 bg-surface-hover rounded-lg"></div>
                </div>
            </div>
        </div>
        }
    </div>
    }

    <!-- Error -->
    @if (error && !isLoading) {
    <div
        class="flex items-center gap-3 px-6 py-4 bg-danger-soft border border-danger-border rounded-2xl text-danger text-sm font-medium">
        <i class="fas fa-exclamation-circle text-lg"></i><span>{{ error }}</span>
        <button (click)="load()" class="ml-auto underline hover:no-underline font-bold">{{
            'brokerDashboard.common.retry' | translate }}</button>
    </div>
    }

    <!-- Empty State -->
    @if (!isLoading && !error && units.length === 0) {
    <div
        class="bg-surface-elevated rounded-2xl border border-border shadow-subtle flex flex-col items-center justify-center py-20 text-center">
        <div
            class="w-20 h-20 bg-surface border border-border-strong rounded-full flex items-center justify-center mx-auto mb-4 hover:bg-surface-hover transition-colors">
            <i class="fas fa-building text-text-muted text-3xl"></i>
        </div>
        <p class="text-lg font-bold text-text-primary mb-4">{{ 'brokerDashboard.units.noUnits' | translate }}</p>
        <button [routerLink]="['/dashboard/real_estate_broker/add-property']"
            class="px-5 py-2.5 bg-primary text-white rounded-xl font-bold shadow-primary-glow hover:bg-primary-hover transition-colors">
            إضافة وحدة
        </button>
    </div>
    }

    <!-- Units Grid -->
    @if (!isLoading && !error && units.length > 0) {
    <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        @for (unit of units; track unit._id) {
        <div
            class="bg-surface-elevated rounded-2xl border border-border shadow-subtle overflow-hidden hover:border-primary-border hover:shadow-primary-glow/20 transition-all group flex flex-col">

            <!-- Thumbnail -->
            <div class="relative h-48 bg-surface-hover overflow-hidden">
                @if (thumbnail(unit)) {
                <img [src]="thumbnail(unit)" [alt]="unit.title"
                    class="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <!-- Dark gradient overlay for text readability -->
                <div class="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                } @else {
                <div class="w-full h-full flex items-center justify-center text-text-disabled">
                    <i class="fas fa-image text-5xl opacity-20"></i>
                </div>
                }

                <!-- Badges overlay -->
                <div class="absolute top-3 left-3 flex gap-2 flex-wrap">
                    <span
                        class="px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider backdrop-blur-md bg-black/50 text-white border border-white/20">
                        {{ unit.purpose }}
                    </span>
                    <span class="px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider backdrop-blur-md"
                        [ngClass]="unit.status === 'active' ? 'bg-success/80 text-white border border-success' : 'bg-black/50 text-white border border-white/20'">
                        {{ unit.status }}
                    </span>
                </div>
                @if (unit.isFeatured) {
                <div class="absolute top-3 right-3">
                    <span
                        class="px-2.5 py-1 rounded-md text-[10px] font-bold uppercase tracking-wider bg-warning text-warning-content border border-warning">
                        <i class="fas fa-star mr-1"></i>{{ 'brokerDashboard.units.featured' | translate }}
                    </span>
                </div>
                }
            </div>

            <!-- Content -->
            <div class="p-5 flex flex-col flex-grow">
                <h3
                    class="text-text-primary font-bold text-base mb-1 truncate group-hover:text-primary transition-colors">
                    {{ unit.title || unit.title_en }}</h3>
                <p class="text-xs font-medium text-text-secondary mb-4 flex items-center gap-1.5">
                    <i class="fas fa-map-marker-alt text-primary/70"></i>
                    <span class="truncate">{{ unit.location.area.en || unit.location.area }}, {{ unit.location.city.en
                        || unit.location.city }}</span>
                </p>

                <!-- Stats row -->
                <div
                    class="flex items-center gap-4 text-xs font-bold text-text-secondary mb-4 p-3 bg-surface rounded-xl border border-border-subtle">
                    <span class="flex items-center gap-1.5" title="Bedrooms"><i
                            class="fas fa-bed text-text-muted"></i>{{ unit.bedrooms }}</span>
                    <span class="flex items-center gap-1.5" title="Bathrooms"><i
                            class="fas fa-bath text-text-muted"></i>{{ unit.bathrooms }}</span>
                    <span class="flex items-center gap-1.5" title="Area"><i
                            class="fas fa-ruler-combined text-text-muted"></i>{{ unit.unitArea }}m²</span>
                    <span class="flex items-center gap-1.5 ml-auto" title="Views"><i
                            class="fas fa-eye text-primary"></i>{{ unit.viewsCount }}</span>
                </div>

                <!-- Unit type + furnished -->
                <div class="flex items-center gap-2 flex-wrap mb-5">
                    <span
                        class="px-2.5 py-1 bg-surface text-text-primary border border-border rounded-md text-[10px] font-bold uppercase tracking-wider">{{
                        unit.unitType || unit.unitType_en }}</span>
                    @if (unit.furnished) {
                    <span
                        class="px-2.5 py-1 bg-primary-soft text-primary border border-primary-border rounded-md text-[10px] font-bold uppercase tracking-wider">
                        <i class="fas fa-couch mr-1"></i>{{ 'brokerDashboard.units.furnished' | translate }}
                    </span>
                    }
                    <span
                        class="px-2.5 py-1 bg-surface text-text-secondary border border-border rounded-md text-[10px] font-bold uppercase tracking-wider">{{
                        'brokerDashboard.units.floor' | translate }} {{ unit.floorNumber }}</span>
                </div>

                <div class="mt-auto pt-4 border-t border-border-subtle">
                    <!-- Action Buttons -->
                    <div class="flex gap-2">
                        <button (click)="openEditModal(unit)"
                            class="flex-1 px-3 py-2.5 bg-surface text-text-primary border border-border rounded-xl font-bold hover:bg-surface-hover hover:border-primary transition-colors text-xs flex items-center justify-center gap-1.5"
                            title="{{ 'brokerDashboard.units.edit' | translate }}">
                            <i class="fas fa-edit text-primary"></i>{{ 'brokerDashboard.units.edit' | translate }}
                        </button>
                        <button (click)="openPricing(unit)"
                            class="w-10 h-10 flex items-center justify-center border border-border bg-surface text-warning font-bold rounded-xl hover:bg-warning-soft hover:border-warning-border transition-colors text-sm"
                            title="{{ 'brokerDashboard.units.seasonalPricing' | translate }}">
                            <i class="fas fa-tags"></i>
                        </button>
                        <button (click)="openAvailabilityPanel(unit)"
                            class="w-10 h-10 flex items-center justify-center border border-border bg-surface text-success font-bold rounded-xl hover:bg-success-soft hover:border-success-border transition-colors text-sm"
                            title="{{ 'brokerDashboard.units.availability' | translate }}">
                            <i class="fas fa-calendar-days"></i>
                        </button>
                        <button (click)="openDeleteModal(unit)"
                            class="w-10 h-10 flex items-center justify-center border border-border bg-surface text-danger font-bold rounded-xl hover:bg-danger-soft hover:border-danger-border transition-colors text-sm"
                            title="{{ 'brokerDashboard.units.delete' | translate }}">
                            <i class="fas fa-trash"></i>
                        </button>
                    </div>
                </div>
            </div>

        </div>
        }
    </div>

    <!-- Pagination -->
    @if (totalPages > 1) {
    <div class="flex items-center justify-center gap-2 mt-8">
        <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
            class="w-10 h-10 flex items-center justify-center border border-border bg-surface text-text-primary rounded-xl hover:bg-surface-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-bold">
            <i class="fas fa-chevron-left"></i>
        </button>

        @for (page of Array(totalPages); track $index) {
        <button (click)="changePage($index + 1)"
            [class]="currentPage === $index + 1 ? 'w-10 h-10 bg-primary text-white rounded-xl font-bold shadow-primary-glow' : 'w-10 h-10 border border-border bg-surface text-text-primary rounded-xl hover:bg-surface-hover transition-colors font-bold'">
            {{ $index + 1 }}
        </button>
        }

        <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
            class="w-10 h-10 flex items-center justify-center border border-border bg-surface text-text-primary rounded-xl hover:bg-surface-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-bold">
            <i class="fas fa-chevron-right"></i>
        </button>
    </div>
    }
    }

</div>

<!-- Create Unit Modal -->
@if (showCreateModal) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-bg-base rounded-2xl border border-border max-w-6xl w-full max-h-[92vh] overflow-hidden shadow-elevated flex flex-col">
        <div class="flex items-center justify-between border-b border-border-subtle bg-surface px-6 py-4">
            <div>
                <h3 class="text-lg font-bold text-text-primary flex items-center gap-2">
                    <i class="fas fa-building-circle-plus text-primary"></i>
                    إضافة وحدة
                </h3>
                <p class="text-xs text-text-secondary mt-1">أضف وحدة جديدة من داخل لوحة الوسيط</p>
            </div>
            <button (click)="closeCreateModal()"
                class="w-9 h-9 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="flex-1 overflow-y-auto custom-scrollbar p-5">
            <app-add-new-property [isModalMode]="true" (created)="onUnitCreated()"></app-add-new-property>
        </div>
    </div>
</div>
}

<!-- Edit Unit Modal -->
@if (showEditModal && editingUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-bg-base rounded-2xl border border-border max-w-5xl w-full max-h-[82vh] overflow-hidden shadow-elevated flex flex-col">
        <div class="flex items-center justify-between border-b border-border-subtle bg-surface px-6 py-4">
            <div>
                <h3 class="text-lg font-bold text-text-primary flex items-center gap-2">
                    <i class="fas fa-pen-to-square text-primary"></i>
                    تعديل الوحدة
                </h3>
                <p class="text-xs text-text-secondary mt-1">{{ editingUnit.title || editingUnit.title_en }}</p>
            </div>
            <div class="flex items-center gap-2">
                <button type="button" (click)="openPricing(editingUnit)"
                    class="px-3 py-1.5 bg-warning/10 text-warning border border-warning/30 rounded-xl text-xs font-bold hover:bg-warning hover:text-white transition-colors flex items-center gap-1.5"
                    title="{{ 'brokerDashboard.units.seasonalPricing' | translate }}">
                    <i class="fas fa-tags"></i>
                    <span>{{ 'brokerDashboard.units.seasonalPricing' | translate }}</span>
                </button>
                <button type="button" (click)="openAvailabilityPanel(editingUnit)"
                    class="px-3 py-1.5 bg-success/10 text-success border border-success/30 rounded-xl text-xs font-bold hover:bg-success hover:text-white transition-colors flex items-center gap-1.5"
                    title="{{ 'brokerDashboard.units.availability' | translate }}">
                    <i class="fas fa-calendar-days"></i>
                    <span>{{ 'brokerDashboard.units.availability' | translate }}</span>
                </button>
                <button (click)="closeEditModal()"
                    class="w-9 h-9 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                    <i class="fas fa-times"></i>
                </button>
            </div>
        </div>

        <div class="flex-1 overflow-y-auto custom-scrollbar p-5">
            <app-update-property [unitId]="editingUnit._id" [ownerType]="'broker'"
                [isModalMode]="true"></app-update-property>
        </div>
    </div>
</div>
}

<!-- Delete Unit Modal -->
@if (showDeleteModal && selectedUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div class="bg-surface-elevated rounded-2xl border border-border max-w-md w-full p-6 shadow-elevated">
        <div class="flex items-center justify-between mb-6 border-b border-border-subtle pb-4">
            <h3 class="text-lg font-bold text-text-primary">{{ 'brokerDashboard.units.deleteUnit' | translate }}</h3>
            <button (click)="closeDeleteModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="mb-8">
            <p class="text-text-secondary font-medium mb-4">{{ 'brokerDashboard.units.deleteConfirmMessage' | translate
                }}</p>
            <div class="p-4 bg-danger-soft/10 border border-danger-border rounded-xl">
                <p class="font-bold text-text-primary">{{ selectedUnit.title || selectedUnit.title_en }}</p>
                <p class="text-xs font-bold text-danger mt-1 uppercase tracking-wider">{{ selectedUnit.unitNumber }}</p>
            </div>
        </div>

        <div class="flex gap-3">
            <button (click)="closeDeleteModal()"
                class="flex-1 px-4 py-3 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.common.cancel' | translate }}
            </button>
            <button (click)="deleteUnit()" [disabled]="deleteLoading"
                class="flex-1 px-4 py-3 bg-danger text-white font-bold rounded-xl hover:bg-danger/90 transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                @if (deleteLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                }
                {{ 'brokerDashboard.units.delete' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Gallery Modal -->
@if (showGalleryModal && selectedUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-surface-elevated rounded-2xl border border-border max-w-4xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar p-6 shadow-elevated flex flex-col">
        <div class="flex items-center justify-between mb-6 border-b border-border-subtle pb-4">
            <h3 class="text-lg font-bold text-text-primary flex items-center gap-2"><i
                    class="fas fa-images text-primary"></i> {{ 'brokerDashboard.units.manageGallery' | translate }}</h3>
            <button (click)="closeGalleryModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Current Gallery -->
        @if (selectedUnit.gallery && selectedUnit.gallery.length > 0) {
        <div class="mb-8">
            <h4 class="font-bold text-text-primary mb-4 uppercase tracking-wider text-sm">{{
                'brokerDashboard.units.currentGallery' | translate }}</h4>
            <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                @for (image of selectedUnit.gallery; track image._id) {
                <div
                    class="relative group rounded-xl overflow-hidden border border-border hover:border-primary transition-colors">
                    <img [src]="image.secure_url" class="w-full h-32 object-cover">
                    <div class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
                    </div>
                    <button (click)="toggleGalleryDelete(image.public_id)"
                        [class]="galleryToDelete.includes(image.public_id) ? 'absolute top-2 right-2 w-8 h-8 bg-danger text-white rounded-lg flex items-center justify-center shadow-lg' : 'absolute top-2 right-2 w-8 h-8 bg-black/60 text-white rounded-lg flex items-center justify-center opacity-0 group-hover:opacity-100 hover:bg-danger transition-all'">
                        <i class="fas" [class.fa-undo]="galleryToDelete.includes(image.public_id)"
                            [class.fa-trash]="!galleryToDelete.includes(image.public_id)"></i>
                    </button>
                </div>
                }
            </div>
        </div>
        }

        <!-- Upload New Images -->
        <div class="mb-8 p-6 bg-surface border border-border border-dashed rounded-xl text-center">
            <i class="fas fa-cloud-upload-alt text-4xl text-text-muted mb-3"></i>
            <h4 class="font-bold text-text-primary mb-1">{{ 'brokerDashboard.units.addNewImages' | translate }}</h4>
            <p class="text-xs text-text-secondary mb-4">Drag and drop images here, or click to browse.</p>
            <input type="file" multiple accept="image/*" (change)="onGalleryFilesSelected($event)"
                class="block w-full max-w-sm mx-auto text-sm text-text-secondary file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-bold file:bg-primary-soft file:text-primary hover:file:bg-primary hover:file:text-white transition-colors cursor-pointer">
        </div>

        <div class="flex gap-3 mt-auto pt-4 border-t border-border-subtle">
            <button (click)="closeGalleryModal()"
                class="flex-1 px-4 py-3 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.common.cancel' | translate }}
            </button>
            <button (click)="updateGallery()" [disabled]="galleryLoading"
                class="flex-1 px-4 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-hover shadow-primary-glow transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                @if (galleryLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                }
                {{ 'brokerDashboard.units.updateGallery' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Features Modal -->
@if (showFeaturesModal && selectedUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-surface-elevated rounded-2xl border border-border max-w-2xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar p-6 shadow-elevated flex flex-col">
        <div class="flex items-center justify-between mb-6 border-b border-border-subtle pb-4">
            <h3 class="text-lg font-bold text-text-primary flex items-center gap-2"><i
                    class="fas fa-list-check text-primary"></i> {{ 'brokerDashboard.units.manageFeatures' | translate }}
            </h3>
            <button (click)="closeFeaturesModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Current Features -->
        @if (selectedUnit.facilitiesAndServices_en && selectedUnit.facilitiesAndServices_en.length > 0) {
        <div class="mb-8">
            <h4 class="font-bold text-text-primary mb-4 uppercase tracking-wider text-sm">{{
                'brokerDashboard.units.currentFeatures' | translate }}</h4>
            <div class="space-y-3">
                @for (feature of selectedUnit.facilitiesAndServices_en; track $index) {
                <div
                    class="flex items-center justify-between p-4 bg-surface border border-border rounded-xl group hover:border-primary-border transition-colors">
                    <div>
                        <p class="font-bold text-text-primary text-sm">{{ feature }}</p>
                        <p class="text-xs font-medium text-text-secondary mt-0.5" dir="rtl">{{
                            selectedUnit.facilitiesAndServices_ar[$index] }}</p>
                    </div>
                    <button (click)="removeFeature($index)"
                        class="w-8 h-8 flex items-center justify-center rounded-lg text-text-muted hover:bg-danger-soft hover:text-danger transition-colors">
                        <i class="fas fa-trash text-sm"></i>
                    </button>
                </div>
                }
            </div>
        </div>
        }

        <!-- Add New Feature -->
        <div class="mb-6 p-5 bg-surface border border-border rounded-xl">
            <h4 class="font-bold text-text-primary mb-4 uppercase tracking-wider text-xs"><i
                    class="fas fa-plus mr-1"></i> {{ 'brokerDashboard.units.addNewFeature' | translate }}</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <input type="text" [(ngModel)]="newFeatureEn"
                    placeholder="{{ 'brokerDashboard.units.featureEn' | translate }}"
                    class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary placeholder-text-muted focus:ring-2 focus:ring-primary focus:border-primary transition">
                <input type="text" [(ngModel)]="newFeatureAr" dir="rtl"
                    placeholder="{{ 'brokerDashboard.units.featureAr' | translate }}"
                    class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary placeholder-text-muted focus:ring-2 focus:ring-primary focus:border-primary transition">
            </div>
            <button (click)="addFeature()" [disabled]="!newFeatureEn.trim() || !newFeatureAr.trim() || featuresLoading"
                class="w-full py-2.5 bg-success-soft text-success border border-success-border font-bold rounded-xl hover:bg-success hover:text-white transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                @if (featuresLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                } @else {
                <i class="fas fa-check"></i>
                }
                {{ 'brokerDashboard.units.addFeature' | translate }}
            </button>
        </div>

        <div class="mt-auto pt-4 border-t border-border-subtle">
            <button (click)="closeFeaturesModal()"
                class="w-full px-4 py-3 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.common.close' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Price Modal -->
@if (showPriceModal && selectedUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-surface-elevated rounded-2xl border border-border max-w-4xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar p-6 shadow-elevated flex flex-col">
        <div class="flex items-center justify-between mb-6 border-b border-border-subtle pb-4">
            <h3 class="text-lg font-bold text-text-primary flex items-center gap-2"><i
                    class="fas fa-money-bill-wave text-success"></i> {{ 'brokerDashboard.units.managePrice' | translate
                }}</h3>
            <button (click)="closePriceModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <div class="space-y-8">
            <!-- Rent Price Section -->
            @if (selectedUnit.purpose === 'rent' || selectedUnit.purpose === 'sale_and_rent') {
            <div class="border border-border bg-surface rounded-xl p-6">
                <h4
                    class="font-bold text-text-primary mb-5 uppercase tracking-wider text-sm flex items-center gap-2 border-b border-border-subtle pb-2">
                    <i class="fas fa-key text-primary"></i> {{ 'brokerDashboard.units.rentPrice' | translate }}
                </h4>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mb-6">
                    <div>
                        <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                            'brokerDashboard.units.rentType' | translate }}</label>
                        <select [(ngModel)]="priceForm.rentPrice.rentType"
                            class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                            <option value="daily" class="bg-surface">{{ 'brokerDashboard.units.daily' | translate }}
                            </option>
                            <option value="weekly" class="bg-surface">{{ 'brokerDashboard.units.weekly' | translate }}
                            </option>
                            <option value="monthly" class="bg-surface">{{ 'brokerDashboard.units.monthly' | translate }}
                            </option>
                        </select>
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                            'brokerDashboard.units.basePrice' | translate }}</label>
                        <div class="relative">
                            <span
                                class="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted font-bold text-sm">EGP</span>
                            <input type="number" [(ngModel)]="priceForm.rentPrice.price"
                                class="w-full pl-12 pr-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                            'brokerDashboard.units.securityDeposit' | translate }}</label>
                        <div class="relative">
                            <span
                                class="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted font-bold text-sm">EGP</span>
                            <input type="number" [(ngModel)]="priceForm.rentPrice.securityDeposit"
                                class="w-full pl-12 pr-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                </div>

                <!-- Commission -->
                <div class="p-4 bg-surface-hover rounded-xl border border-border-subtle mb-6">
                    <h5 class="text-xs font-bold text-text-primary mb-3 uppercase tracking-wider"><i
                            class="fas fa-handshake mr-1 text-primary"></i> Commission</h5>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-text-secondary mb-2 uppercase">{{
                                'brokerDashboard.units.commissionType' | translate }}</label>
                            <select [(ngModel)]="priceForm.rentPrice.commission.type"
                                class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                                <option value="percentage" class="bg-surface">{{ 'brokerDashboard.units.percentage' |
                                    translate }}</option>
                                <option value="fixed" class="bg-surface">{{ 'brokerDashboard.units.fixed' | translate }}
                                </option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-text-secondary mb-2 uppercase">{{
                                'brokerDashboard.units.commissionValue' | translate }}</label>
                            <input type="number" [(ngModel)]="priceForm.rentPrice.commission.value"
                                class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                </div>

                <!-- Price Tiers -->
                <div>
                    <div class="flex items-center justify-between mb-4">
                        <h5 class="text-sm font-bold text-text-primary uppercase tracking-wider">{{
                            'brokerDashboard.units.priceTiers' | translate }}</h5>
                        <button (click)="addPriceTier()"
                            class="px-3 py-1.5 bg-primary-soft text-primary border border-primary-border rounded-lg font-bold hover:bg-primary hover:text-white transition-colors text-xs flex items-center gap-1">
                            <i class="fas fa-plus"></i>{{ 'brokerDashboard.units.addTier' | translate }}
                        </button>
                    </div>

                    <div class="space-y-3">
                        @for (tier of priceForm.rentPrice.tiers; track $index) {
                        <div
                            class="grid grid-cols-1 md:grid-cols-4 gap-4 p-4 bg-surface-elevated border border-border rounded-xl items-end relative group">
                            <div>
                                <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                    'brokerDashboard.units.minDays' | translate }}</label>
                                <input type="number" [(ngModel)]="tier.minDays"
                                    class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                            </div>
                            <div>
                                <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                    'brokerDashboard.units.pricePerDay' | translate }}</label>
                                <input type="number" [(ngModel)]="tier.pricePerDay"
                                    class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                            </div>
                            <div>
                                <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                    'brokerDashboard.units.label' | translate }}</label>
                                <input type="text" [(ngModel)]="tier.label"
                                    class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                            </div>
                            <div class="flex justify-end pb-1 md:absolute md:-right-3 md:-top-3">
                                <button (click)="removePriceTier($index)"
                                    class="w-7 h-7 bg-surface border border-border text-danger rounded-full shadow-sm hover:bg-danger hover:text-white transition-colors flex items-center justify-center opacity-100 md:opacity-0 group-hover:opacity-100">
                                    <i class="fas fa-times text-xs"></i>
                                </button>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }

            <!-- Sale Price Section -->
            @if (selectedUnit.purpose === 'sale' || selectedUnit.purpose === 'sale_and_rent') {
            <div class="border border-border bg-surface rounded-xl p-6">
                <h4
                    class="font-bold text-text-primary mb-5 uppercase tracking-wider text-sm flex items-center gap-2 border-b border-border-subtle pb-2">
                    <i class="fas fa-tag text-primary"></i> {{ 'brokerDashboard.units.salePrice' | translate }}
                </h4>

                <div class="grid grid-cols-1 md:grid-cols-3 gap-5 mb-6">
                    <div>
                        <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                            'brokerDashboard.units.basePrice' | translate }}</label>
                        <div class="relative">
                            <span
                                class="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted font-bold text-sm">EGP</span>
                            <input type="number" [(ngModel)]="priceForm.salePrice.basePrice"
                                class="w-full pl-12 pr-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                    <div>
                        <label class="block text-xs font-bold text-text-secondary mb-2 uppercase tracking-wider">{{
                            'brokerDashboard.units.pricePerMeter' | translate }}</label>
                        <div class="relative">
                            <span
                                class="absolute left-4 top-1/2 -translate-y-1/2 text-text-muted font-bold text-sm">EGP</span>
                            <input type="number" [(ngModel)]="priceForm.salePrice.pricePerMeter"
                                class="w-full pl-12 pr-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                    <div class="flex items-end pb-2">
                        <label class="flex items-center cursor-pointer group">
                            <div class="relative flex items-center">
                                <input type="checkbox" [(ngModel)]="priceForm.salePrice.negotiable" class="sr-only">
                                <div class="w-5 h-5 border-2 rounded transition-colors"
                                    [ngClass]="priceForm.salePrice.negotiable ? 'bg-primary border-primary' : 'bg-surface-input border-border group-hover:border-primary'">
                                    @if (priceForm.salePrice.negotiable) { <i
                                        class="fas fa-check text-white text-xs absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"></i>
                                    }
                                </div>
                            </div>
                            <span class="ml-3 text-sm font-bold text-text-primary uppercase tracking-wider">{{
                                'brokerDashboard.units.negotiable' | translate }}</span>
                        </label>
                    </div>
                </div>

                <!-- Commission -->
                <div class="p-4 bg-surface-hover rounded-xl border border-border-subtle mb-6">
                    <h5 class="text-xs font-bold text-text-primary mb-3 uppercase tracking-wider"><i
                            class="fas fa-handshake mr-1 text-primary"></i> Commission</h5>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label class="block text-xs font-bold text-text-secondary mb-2 uppercase">{{
                                'brokerDashboard.units.commissionType' | translate }}</label>
                            <select [(ngModel)]="priceForm.salePrice.commission.type"
                                class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                                <option value="percentage" class="bg-surface">{{ 'brokerDashboard.units.percentage' |
                                    translate }}</option>
                                <option value="fixed" class="bg-surface">{{ 'brokerDashboard.units.fixed' | translate }}
                                </option>
                            </select>
                        </div>
                        <div>
                            <label class="block text-xs font-bold text-text-secondary mb-2 uppercase">{{
                                'brokerDashboard.units.commissionValue' | translate }}</label>
                            <input type="number" [(ngModel)]="priceForm.salePrice.commission.value"
                                class="w-full px-4 py-2.5 bg-surface-input border border-border rounded-xl text-sm text-text-primary focus:ring-2 focus:ring-primary focus:border-primary transition">
                        </div>
                    </div>
                </div>

                <!-- Sale Plans -->
                <div>
                    <div class="flex items-center justify-between mb-4">
                        <h5 class="text-sm font-bold text-text-primary uppercase tracking-wider">{{
                            'brokerDashboard.units.salePlans' | translate }}</h5>
                        <button (click)="addSalePlan()"
                            class="px-3 py-1.5 bg-primary-soft text-primary border border-primary-border rounded-lg font-bold hover:bg-primary hover:text-white transition-colors text-xs flex items-center gap-1">
                            <i class="fas fa-plus"></i>{{ 'brokerDashboard.units.addPlan' | translate }}
                        </button>
                    </div>

                    <div class="space-y-4">
                        @for (plan of priceForm.salePrice.plans; track $index) {
                        <div class="p-5 bg-surface-elevated border border-border rounded-xl relative group">
                            <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.planNameEn' | translate }}</label>
                                    <input type="text" [(ngModel)]="plan.name_en"
                                        class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.planNameAr' | translate }}</label>
                                    <input type="text" [(ngModel)]="plan.name_ar" dir="rtl"
                                        class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.saleType' | translate }}</label>
                                    <select [(ngModel)]="plan.saleType"
                                        class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                                        <option value="cash" class="bg-surface">{{ 'brokerDashboard.units.cash' |
                                            translate }}</option>
                                        <option value="installment" class="bg-surface">{{
                                            'brokerDashboard.units.installment' | translate }}</option>
                                    </select>
                                </div>
                            </div>

                            @if (plan.saleType === 'installment') {
                            <div
                                class="grid grid-cols-1 md:grid-cols-4 gap-4 p-4 bg-surface-hover rounded-lg border border-border-subtle">
                                <div>
                                    <label
                                        class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase truncate"
                                        title="Down Payment %">{{ 'brokerDashboard.units.downPaymentPercent' | translate
                                        }}</label>
                                    <div class="relative"><input type="number" [(ngModel)]="plan.downPaymentPercent"
                                            class="w-full px-3 py-2 pr-8 bg-surface-input border border-border rounded-lg text-sm text-text-primary"><span
                                            class="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted font-bold">%</span>
                                    </div>
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.years' | translate }}</label>
                                    <input type="number" [(ngModel)]="plan.years"
                                        class="w-full px-3 py-2 bg-surface-input border border-border rounded-lg text-sm text-text-primary">
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.interestRate' | translate }}</label>
                                    <div class="relative"><input type="number" [(ngModel)]="plan.interestRate"
                                            class="w-full px-3 py-2 pr-8 bg-surface-input border border-border rounded-lg text-sm text-text-primary"><span
                                            class="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted font-bold">%</span>
                                    </div>
                                </div>
                                <div>
                                    <label class="block text-[10px] font-bold text-text-secondary mb-1.5 uppercase">{{
                                        'brokerDashboard.units.discountPercent' | translate }}</label>
                                    <div class="relative"><input type="number" [(ngModel)]="plan.discountPercent"
                                            class="w-full px-3 py-2 pr-8 bg-surface-input border border-border rounded-lg text-sm text-text-primary"><span
                                            class="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted font-bold">%</span>
                                    </div>
                                </div>
                            </div>
                            }

                            <button (click)="removeSalePlan($index)"
                                class="absolute -right-3 -top-3 w-8 h-8 bg-surface border border-border text-danger rounded-full shadow-md hover:bg-danger hover:text-white transition-colors flex items-center justify-center opacity-100 md:opacity-0 group-hover:opacity-100">
                                <i class="fas fa-times text-sm"></i>
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </div>
            }
        </div>

        <div class="flex gap-3 mt-8 pt-6 border-t border-border-subtle">
            <button (click)="closePriceModal()"
                class="flex-1 px-4 py-3 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.common.cancel' | translate }}
            </button>
            <button (click)="updatePrice()" [disabled]="priceLoading"
                class="flex-1 px-4 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-hover shadow-primary-glow transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                @if (priceLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                }
                <i class="fas fa-save"></i> {{ 'brokerDashboard.units.updatePrice' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Documents Modal -->
@if (showDocumentsModal && selectedUnit) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
    <div
        class="bg-surface-elevated rounded-2xl border border-border max-w-4xl w-full max-h-[90vh] overflow-y-auto custom-scrollbar p-6 shadow-elevated flex flex-col">
        <div class="flex items-center justify-between mb-6 border-b border-border-subtle pb-4">
            <h3 class="text-lg font-bold text-text-primary flex items-center gap-2"><i
                    class="fas fa-file-pdf text-info"></i> {{ 'brokerDashboard.units.manageDocuments' | translate }}
            </h3>
            <button (click)="closeDocumentsModal()"
                class="w-8 h-8 flex items-center justify-center rounded-full text-text-secondary hover:bg-surface-hover hover:text-danger transition-colors">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Current Documents -->
        @if (selectedUnit.documents && selectedUnit.documents.length > 0) {
        <div class="mb-8">
            <h4 class="font-bold text-text-primary mb-4 uppercase tracking-wider text-sm">{{
                'brokerDashboard.units.currentDocuments' | translate }}</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                @for (document of selectedUnit.documents; track document._id) {
                <div
                    class="relative bg-surface border border-border rounded-xl p-4 flex items-center gap-4 group hover:border-primary-border transition-colors">
                    <div
                        class="w-12 h-12 bg-surface-hover rounded-lg flex items-center justify-center border border-border-subtle shrink-0">
                        <i class="fas fa-file-alt text-text-muted text-xl"></i>
                    </div>
                    <div class="flex-1 min-w-0">
                        <p class="font-bold text-text-primary text-sm truncate mb-0.5">{{ document.public_id }}</p>
                        <a [href]="document.secure_url" target="_blank"
                            class="text-xs font-bold text-primary hover:text-primary-hover uppercase tracking-wider">
                            <i class="fas fa-external-link-alt mr-1"></i> {{ 'brokerDashboard.units.viewDocument' |
                            translate }}
                        </a>
                    </div>
                    <button (click)="toggleDocumentDelete(document.public_id)"
                        [class]="documentsToDelete.includes(document.public_id) ? 'w-8 h-8 bg-danger text-white rounded-lg text-sm shrink-0 shadow-sm' : 'w-8 h-8 bg-surface-hover text-text-muted rounded-lg text-sm shrink-0 hover:bg-danger hover:text-white transition-colors'">
                        <i class="fas" [class.fa-undo]="documentsToDelete.includes(document.public_id)"
                            [class.fa-trash]="!documentsToDelete.includes(document.public_id)"></i>
                    </button>
                </div>
                }
            </div>
        </div>
        }

        <!-- Upload New Documents -->
        <div class="mb-8 p-6 bg-surface border border-border border-dashed rounded-xl text-center">
            <i class="fas fa-file-upload text-4xl text-text-muted mb-3"></i>
            <h4 class="font-bold text-text-primary mb-1">{{ 'brokerDashboard.units.addNewDocuments' | translate }}</h4>
            <p class="text-xs text-text-secondary mb-4">{{ 'brokerDashboard.units.documentFormats' | translate }}</p>
            <input type="file" multiple accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                (change)="onDocumentFilesSelected($event)"
                class="block w-full max-w-sm mx-auto text-sm text-text-secondary file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-bold file:bg-primary-soft file:text-primary hover:file:bg-primary hover:file:text-white transition-colors cursor-pointer">
        </div>

        <div class="flex gap-3 mt-auto pt-4 border-t border-border-subtle">
            <button (click)="closeDocumentsModal()"
                class="flex-1 px-4 py-3 border border-border text-text-primary font-bold rounded-xl hover:bg-surface-hover hover:border-border-strong transition-colors">
                {{ 'brokerDashboard.common.cancel' | translate }}
            </button>
            <button (click)="updateDocuments()" [disabled]="documentsLoading"
                class="flex-1 px-4 py-3 bg-primary text-white font-bold rounded-xl hover:bg-primary-hover shadow-primary-glow transition-colors disabled:opacity-50 flex items-center justify-center gap-2">
                @if (documentsLoading) {
                <i class="fas fa-spinner fa-spin"></i>
                }
                <i class="fas fa-upload"></i> {{ 'brokerDashboard.units.updateDocuments' | translate }}
            </button>
        </div>
    </div>
</div>
}

<!-- Seasonal Pricing Panel -->
@if (pricingUnitId) {
<div class="relative z-[60]">
    <app-seasonal-pricing-panel [unitId]="pricingUnitId" (closed)="closePricing()" />
</div>
}

<!-- Availability Panel -->
@if (availabilityUnitId) {
<div class="fixed inset-0 bg-black/80 backdrop-blur-sm z-[60] flex items-center justify-center p-4"
    (click)="closeAvailabilityPanel()">
    <div class="bg-surface-elevated rounded-2xl shadow-elevated border border-border w-full max-w-2xl max-h-[90vh] flex flex-col"
        (click)="$event.stopPropagation()">
        <div
            class="flex items-center justify-between px-6 py-5 border-b border-border bg-surface rounded-t-2xl shrink-0">
            <div class="flex items-center gap-4">
                <div
                    class="w-10 h-10 bg-success-soft rounded-xl flex items-center justify-center border border-success-border shrink-0">
                    <i class="fa-solid fa-calendar-days text-success text-lg"></i>
                </div>
                <div>
                    <h2 class="text-text-primary font-bold text-base tracking-tight uppercase">إدارة التوافر</h2>
                    <p class="text-text-secondary text-xs mt-0.5 font-mono truncate max-w-[200px]">{{ availabilityUnitId
                        }}</p>
                </div>
            </div>
            <button (click)="closeAvailabilityPanel()"
                class="w-8 h-8 flex items-center justify-center rounded-full hover:bg-surface-hover transition-colors text-text-secondary hover:text-danger shrink-0">
                <i class="fa-solid fa-times"></i>
            </button>
        </div>
        <div class="flex-1 overflow-y-auto p-6 custom-scrollbar">
            <app-availability [unitId]="availabilityUnitId" />
        </div>
    </div>
</div>
}